import { render, staticRenderFns } from "./faculties.vue?vue&type=template&id=29ab828e&"
import script from "./faculties.vue?vue&type=script&lang=js&"
export * from "./faculties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports